import { PageId } from 'constants/pages'
import type { TStep } from 'src/types'

export const STEPS_INTL_HLWN70: TStep[] = [
  {
    pageId: PageId.OFFER_INTL_HLWN70,
  },
  {
    pageId: PageId.PAYMENT_INTL_HLWN70,
  },
  {
    pageId: PageId.CHECKOUT_INTL_HLWN70,
  },
  {
    pageId: PageId.UPSELL_INTL_HLWN70,
  },
  {
    pageId: PageId.REGISTRATION_INTL_HLWN70,
  },
  {
    pageId: PageId.NAME_ENTRY_INTL_HLWN70,
  },
  {
    pageId: PageId.CERTIFICATE_INTL_HLWN70,
  },
  {
    pageId: PageId.LEARNWORLDS_REDIRECT_INTL_HLWN70,
  },
  {
    pageId: PageId.REPORT_INTL_HLWN70,
  },
]
